import { SnackBarVariants } from '@app/app.enum';
import CustomSnackBar from '@app/components/shared/snackbar.component';
import * as React from 'react';
import { LogService } from './services/log.service';

class ErrorBoundary extends React.Component<any, { error: Error; errorInfo: React.ErrorInfo; open: boolean }> {
	constructor(props: any) {
		super(props);
		this.state = { error: null, errorInfo: null, open: false };
	}

	public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		// Catch errors in any components below and re-render with error message
		this.setState({
			error,
			errorInfo,
		});
		this.openSnackbar();
		LogService.LogError(`${error} - ${errorInfo.componentStack}`);
	}

	public render() {
		if (this.state.errorInfo) {
			const errorMessage = 'Something Went Wrong !!';
			return (
				<div>
					<CustomSnackBar
						open={this.state.open}
						snackBarMessage={errorMessage}
						autoHideDuration={4000}
						variant={SnackBarVariants.Error}
						onClose={this.closeSnakbar}
						onIconClick={this.closeSnakbar}
					/>
				</div>
			);
		}
		// Normally, just render children
		return this.props.children;
	}

	public openSnackbar = () => {
		this.setState({
			open: true,
		});
	};

	public closeSnakbar = () => {
		this.setState({
			open: false,
		});
	};
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/errorboundary.component.tsx